export default "__VITE_ASSET__aaaea629__"